import { useState, useEffect, useCallback } from 'react';
import useDebounce from '../../context/hooks/useDebounce';
import { Table, Form, InputGroup, Row, Col, Spinner } from 'react-bootstrap';
import ListPaginator from '../../components/ListPaginator';
import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../context/hooks/useAxiosPrivate';
import ExcelSuppliers from './ExcelSuppliers';
import '../../appstyles/ClientsCSS/ClientsList.css';

const SuppliersList = () => {
  const axiosInstance = useAxiosPrivate();
  const [suppliers, setSuppliers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 700);
  const [loading, setLoading] = useState(false)
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  const fetchSuppliers = useCallback((page, searchQuery, pageSize) => {
    setLoading(true)
    const url = searchQuery
      ? `api/supplier/?page=${page}&size=${pageSize}&supplier_name=${searchQuery}`
      : `api/supplier/?page=${page}&size=${pageSize}`;

    axiosInstance.get(url)
      .then(response => {
        console.log('Fetched data:', response.data);
        setSuppliers(response.data);
        setTotalPages(response.data.totalPages); // Uncomment when totalPages is available
      })
      .catch(error => {
        console.log('Failed to fetch suppliers', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [axiosInstance]);

  useEffect(() => {
    fetchSuppliers(currentPage, debouncedSearch, rowsPerPage);
  }, [currentPage, debouncedSearch, rowsPerPage, fetchSuppliers]);

  // ...existing code...

  // Use backend results directly

  const handleRowClick = (supplierId) => {
    navigate(`/supplier/details/${supplierId}`);
  };

   // Handle page change
   const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  return (
    <div className='maestros-list'>
    <h2>Lista de Proveedores</h2>
    <hr />
    <Form inline style={{ width: '50%' }} onSubmit={(e) => e.preventDefault()}>
        <InputGroup>
          <Form.Control
            type="search"
            placeholder="Buscar por nombre de proveedor"            
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          >
          </Form.Control>
        </InputGroup>
    </Form>

    {loading ? ( 
      <div className='loading-container'>
      <p style={{fontFamily: 'Roboto, sans-serif'}}>Cargando...</p>
      <Spinner animation="border" variant="info" style={{width: '4.5rem', height: '4.5rem'}} />
      </div>
    ) : (
    <Table striped bordered hover responsive>
      <thead>
        <tr>
          <th>ID</th>
          <th>Nombre Proveedor</th>
          <th>Categoría</th>
          <th>País</th>
          <th>Es financiador</th>
          <th>Estado</th>
        </tr>
      </thead>
      <tbody>
  {suppliers.data && suppliers.data.map(supplier => (
          <tr key={supplier.supplier_id} onClick={() => handleRowClick(supplier.supplier_id)} style={{ cursor: 'pointer' }}>
            <td>{supplier.supplier_id}</td>
            <td>{supplier.supplier_name}</td>
            <td>{supplier.category}</td>
            <td>{supplier.country}</td>
            <td>{supplier.is_financer ? 'Sí' : 'No' }</td>
            <td>{supplier.status}</td>
          </tr>
        ))}
      </tbody>
    </Table>
    )}

    <Row>
      <Col
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <ExcelSuppliers/>
      </Col>
      <Col>
        <ListPaginator
          currentPage={currentPage}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={value => {
            setRowsPerPage(value);
            setCurrentPage(1);
          }}
        />
      </Col>
    </Row> 
    </div>
  );
};

export default SuppliersList